function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as Factory from "factory";
import * as faker from "faker";
import { nanoid } from "nanoid";
// https://spin.atomicobject.com/2017/03/15/typescript-generate-test-data/
export const webPaywallFactory = Factory.Sync.makeFactoryWithRequired({
    id: Factory.each((i)=>i),
    name: Factory.each(()=>faker.name.firstName()),
    url: "http://web-paywall-ui.superwall.localhost/paywalls/base1",
    identifier: nanoid(),
    primaryProductId: 1,
    substitutions: {
        substitutions: []
    },
    createdAt: new Date(),
    updatedAt: new Date()
});
export const webPaywallWithoutIds = (_param = {})=>{
    var args = _extends({}, _object_destructuring_empty(_param));
    const _webPaywallFactory_build = webPaywallFactory.build(_object_spread({
        applicationId: 1
    }, args)), { applicationId, id, primaryProductId } = _webPaywallFactory_build, webPaywall = _object_without_properties(_webPaywallFactory_build, [
        "applicationId",
        "id",
        "primaryProductId"
    ]);
    return webPaywall;
};
